import AircraftCharacteristics from './AircraftCharacteristics';
export default AircraftCharacteristics;
